import { extendObservable, runInAction } from 'mobx';

import { FAQInfoController } from '../../../../networking/controllers/FAQInfoController';
import { Logger } from '../../../../helpers/Logger';

class FAQStoreClass {
  constructor() {
    extendObservable(this, {
      faqInfo: null,
      loadingFaqInfo: false,
      getError: false,
    });
  }

  async getFaqInfo() {
    runInAction(() => {
      this.loadingFaqInfo = true;
    });
    try {
      const faqInfo = await FAQInfoController.all();
      runInAction(() => {
        this.faqInfo = faqInfo;
      });
    } catch (error) {
      Logger.warn(error);
      runInAction(() => {
        this.getError = true;
      });
    } finally {
      runInAction(() => {
        this.loadingShippingInfo = false;
      });
    }
  }

  clearError() {
    runInAction(() => {
      this.getError = false;
    });
  }
}

const FAQStore = new FAQStoreClass();

export { FAQStore };



// WEBPACK FOOTER //
// ./src/pages/information/help/stores/FAQStore.js